/**
 * Départements français, pour proposer aux clients d'un artisan parti les
 * artisans volontaires de leur secteur (décision du 11 octobre 2026).
 */
const METRO = Array.from({ length: 95 }, (_, i) => String(i + 1).padStart(2, '0'))
  .filter((code) => code !== '20');

/** Codes acceptés : métropole (Corse en 2A / 2B) et départements d'outre-mer. */
export const DEPARTMENT_CODES: readonly string[] = [
  ...METRO.slice(0, 19), '2A', '2B', ...METRO.slice(19), '971', '972', '973', '974', '976',
];

/** Plafond de départements couverts par une entreprise. */
export const MAX_SERVICE_DEPARTMENTS = 30;

/** Département d'un code postal (5 chiffres), ou null s'il n'en a pas. */
export function departmentFromPostalCode(postalCode: string): string | null {
  if (!/^\d{5}$/.test(postalCode)) return null;
  if (postalCode.startsWith('97')) {
    const code = postalCode.slice(0, 3);
    return DEPARTMENT_CODES.includes(code) ? code : null;
  }
  if (postalCode.startsWith('20')) {
    // Corse : 200xx et 201xx en Corse-du-Sud, au-delà en Haute-Corse.
    return Number(postalCode.slice(2, 3)) <= 1 ? '2A' : '2B';
  }
  const code = postalCode.slice(0, 2);
  return DEPARTMENT_CODES.includes(code) ? code : null;
}

/** Département d'une adresse libre : le dernier code postal qu'elle contient. */
export function departmentFromAddress(address: string): string | null {
  const codes = address.match(/(?<!\d)\d{5}(?!\d)/g);
  return codes ? departmentFromPostalCode(codes[codes.length - 1]!) : null;
}

/** Saisie libre (« 34, 30 ; 2a ») → codes valides, sans doublon, triés. */
export function parseDepartments(input: string): { codes: string[]; invalid: string[] } {
  const parts = input.split(/[\s,;]+/).map((part) => part.trim().toUpperCase()).filter(Boolean);
  const codes = new Set<string>();
  const invalid: string[] = [];
  for (const part of parts) {
    const code = /^\d$/.test(part) ? `0${part}` : part;
    if (DEPARTMENT_CODES.includes(code)) codes.add(code);
    else invalid.push(part);
  }
  return {
    codes: [...codes].sort((a, b) => DEPARTMENT_CODES.indexOf(a) - DEPARTMENT_CODES.indexOf(b)),
    invalid,
  };
}
